import React from 'react'
import translatePath from './translatePath'

export const defaultX = 0
export const defaultY = 0
export const width = 550
export const height = 1150

export const path = [
  'M275,0 C425.359523,0 547.53469,120.671572 549.963158,270.452372 L550,275 L550,1075 C550,1116.42136 516.421356,1150 475,1150 C433.992857,1150 400.672357,1117.08957 400.010048,1076.24026 L400,1075 L400,275 C400,205.964406 344.035594,150 275,150 C206.654762,150 151.120595,204.850715 150.016746,272.932896 L150,275 L150,1075 C150,1174 2.985,1174.99 0.0447,1077.97 L0,1075 L0,75 C0,33.5786438 33.5786438,0 75,0 C101.923882,0 125.534217,14.186977 138.763276,35.4932008 L139.025,35.924 L141.123012,34.7308293 C179.50445,13.2990104 223.551314,0.797271327 270.452372,0.0368421431 L275,0 Z',
  'M275,200 C316.007143,200 349.327643,232.910429 349.989952,273.759738 L350,275 L350,1025 C350,1066.42136 316.421356,1100 275,1100 C233.992857,1100 200.672357,1067.08957 200.010048,1026.24026 L200,1025 L200,275 L200.010048,273.759738 C200.672357,232.910429 233.992857,200 275,200 Z'
]

export const getPath = (x, y) => translatePath(path, defaultX, defaultY, x, y)

const N = () => (
  <symbol id="n" viewBox={`${defaultX} ${defaultY} ${width} ${height}`}>
    <path d={path.join(' ')} />
  </symbol>
)

export default N
